import { useContext } from "react";

import { NotificationsContext } from "../contexts";

export function useNotifications() {
  return useContext(NotificationsContext);
}
